import { Component, Type, Input, OnInit } from '@angular/core';
import { ColmecWorkingOrderStepComponent } from '../steps/colmec-working-order-step/colmec-working-order-step.component';

@Component({
    selector: 'colmec-working-order-step-indicator',
    templateUrl: './colmec-working-order-step-indicator.component.html',
    styleUrls: ['./colmec-working-order-step-indicator.component.scss'],
    standalone: false
})
export class ColmecWorkingOrderStepIndicatorComponent implements OnInit {
  @Input()
  currentIndex: number;

  @Input()
  steps: Type<ColmecWorkingOrderStepComponent>[];

  @Input()
  stepIndexVisible: boolean[];

  public stepIndicators: StepIndicator[] = [];

  constructor() {}

  ngOnInit() {
    this.stepIndicators = this.steps
      .filter((_, i) => this.stepIndexVisible[i])
      .map(s => ({
        label: s.prototype.getLabel()
      }));
  }
}

interface StepIndicator {
  label: string;
}
